/* PROJECTS */
export const GET_PROJECTS = 'GET_PROJECTS';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const GET_PROJECTS_FAIL = 'GET_PROJECTS_FAIL';

/* PROJECTS LIST*/
export const GET_PROJECTS_LIST = 'GET_PROJECTS_LIST';
export const GET_PROJECTS_LIST_SUCCESS = 'GET_PROJECTS_LIST_SUCCESS';
export const GET_PROJECTS_LIST_FAIL = 'GET_PROJECTS_LIST_FAIL';

/* PROJECTS DETAIL*/
export const GET_PROJECT_DETAIL = 'GET_PROJECT_DETAIL';
export const GET_PROJECT_DETAIL_SUCCESS = 'GET_PROJECT_DETAIL_SUCCESS';
export const GET_PROJECT_DETAIL_FAIL = 'GET_PROJECT_DETAIL_FAIL';

export const SET_PROJECT_BUTTON_CONDITION = 'SET_PROJECT_BUTTON_CONDITION';
